import administratorService from "../services/administratorService"

export const GET_ALL_CACHING = "GET_ALL_CACHING"
export const GET_ALL_CACHING_SUCCESS = "GET_ALL_CACHING_SUCCESS"
export const GET_ALL_CACHING_ERROR = "GET_ALL_CACHING_ERROR"

export const REMOVE_CACHE = "REMOVE_CACHE"
export const REMOVE_CACHE_SUCCESS = "REMOVE_CACHE_SUCCESS"
export const REMOVE_CACHE_ERROR = "REMOVE_CACHE_ERROR"
export const REMOVE_CACHE_RESET = "REMOVE_CACHE_RESET"

export function getAllCachingDataRecord(query) {
    return async (dispatch) => {
        dispatch(getAllCachingData())
        return await administratorService
            .getAllCachingData(query)
            .then((response) => dispatch(getAllCachingDataSuccess(response)))
            .catch((error) => dispatch(getAllCachingDataError(error)))
    }
}

export function getAllCachingData() {
    return {
        type: GET_ALL_CACHING,
    }
}

export function getAllCachingDataSuccess(success) {
    return {
        type: GET_ALL_CACHING_SUCCESS,
        payload: { success },
    }
}

export function getAllCachingDataError(error) {
    return {
        type: GET_ALL_CACHING_ERROR,
        payload: { error },
    }
}

export function deleteCachingDataRecord(query) {
    return async (dispatch) => {
        dispatch(deleteCachingData())
        return await administratorService
            .deleteCachingData(query)
            .then((response) => dispatch(deleteCachingDataSuccess(response)))
            .catch((error) => dispatch(deleteCachingDataError(error)))
    }
}

export function deleteCachingData() {
    return {
        type: REMOVE_CACHE,
    }
}

export function deleteCachingDataSuccess(success) {
    return {
        type: REMOVE_CACHE_SUCCESS,
        payload: { success },
    }
}

export function deleteCachingDataError(error) {
    return {
        type: REMOVE_CACHE_ERROR,
        payload: { error },
    }
}
export function deleteCachingDataReset() {
  return {
    type: REMOVE_CACHE_RESET,
  };
}